import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { ContactRound } from 'lucide-react'
import { tr } from 'i18n'
import { hasAccess } from 'utils/access'
import { changeOperatorInn } from 'service/AdminPanelService'
import { getErpErrorMessage } from 'service/ErpService'
import OperatorInnDialog from '../OperatorInnDialog/OperatorInnDialog.tsx'
import styles from '../AdminPanelPage.module.scss'
import s from '../Management.module.scss'

export default function OperatorInnChangeAction({ operator, onChanged = () => {} }) {
  useTranslation()
  const user = useSelector(state => state.user)
  const [open, setOpen] = useState(false)
  const [busy, setBusy] = useState(false)
  const busyRef = useRef(false)
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  if (user.is_report_only || !hasAccess(user, 'operators_inn') || operator.employee === null) return null

  const confirm = async (inn, pin) => {
    if (busyRef.current) return
    busyRef.current = true
    setBusy(true); setError(''); setMessage('')
    try {
      await changeOperatorInn(operator.id, inn, pin)
      setOpen(false)
      setMessage(tr('ИНН обновлён. Для входа используйте новый ИНН.'))
      await onChanged()
    } catch (failure) {
      setError(getErpErrorMessage(failure))
    } finally {
      busyRef.current = false
      setBusy(false)
    }
  }
  return <div style={{ display: 'inline-block', verticalAlign: 'top' }} onClick={event => event.stopPropagation()}>
    <button type="button" className={styles.smallBtn} aria-haspopup="dialog" aria-expanded={open} disabled={busy} onClick={() => { setError(''); setMessage(''); setOpen(true) }}>
      <ContactRound size={14} aria-hidden="true" />{tr('Сменить ИНН')}
    </button>
    {message && <p role="status" className={s.muted}>{message}</p>}
    {error && !open && <p role="alert" className={s.error}>{error}</p>}
    {open && <OperatorInnDialog name={operator.employee_name || ''} currentInn={operator.inn || ''} busy={busy} error={error}
      onClose={() => { if (!busy) setOpen(false) }} onConfirm={confirm} />}
  </div>
}
